var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBluetoothSlash = function SvgIconBluetoothSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.85 2.2a1 1 0 0 0-1.6.8v2.597a1 1 0 1 0 2 0V5l3.333 2.5-1.473 1.103a1 1 0 1 0 1.199 1.6l2.54-1.903a1 1 0 0 0 .001-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.24 3.077a1 1 0 0 0-1.48 1.346l6.457 7.102L4.65 15.7a1 1 0 0 0 1.2 1.6l4.4-3.3v7a1 1 0 0 0 1.6.8l4.58-3.44 2.33 2.563a1 1 0 1 0 1.48-1.346zM12.25 19v-5.237l2.83 3.112z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBluetoothSlash;